/**
 * B_Preload.js
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/util/B_Preload.js
 * @목적 : CANVAS GRID 프리로드처리 클래스 (SingleTon)
 * @설명 : SingleTon 처리 취소 => 한 페이지에 다양한 게임가능
 * @진행 : 개발종료
 * @주의 : 'resModel' 이란 것을 가지고 있습니다. 이것은 'Preload Resource를 Wrapping'하기 위한 것입니다.
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

// [I]
import B_Util from 'canvas/base/dev/util/B_Util';

const B_Preload = (function () {

	const $ = {
		__preload : null,
		__cb: null,
		__res: null,
		__src: null,
		__list: null,
		__resModel: null,
		__duplicate: null
	};

	return class {

		constructor(src, resModel) {
			this.__preload = new createjs.LoadQueue(true); // PRELOAD 객체

			// [S] src & resource & duplicate
			this.__src = src;
			this.__resModel = resModel;
			this.__duplicate = [];

			// [#] fileload method
			this.__preload.on("fileload", (e)=>{

				// [S] 중복 등록
				Object.keys(this.__duplicate).forEach((v) => {
					if (e.item.src.indexOf(v) != -1) this.__duplicate[v] = e.result;
				});

				// [*] 리소스 분기
				switch (e.item.type) {
					case createjs.Types.JSON: {
						const key = e.item.id;
						e.result.images.forEach((src2, i) => {
							const id = `${key}-image-${i}`;
							this._res[id] = { src: src2 };
							this.__preload.loadFile({
								id,
								...this._res[id],
								src: `${this._res[id].src}?createjs`
							});
						});
						this._res[e.item.id].result = e.result;
						break;
					}
					case createjs.Types.IMAGE:
						this._res[e.item.id].result = e.result;
						break;
					case createjs.Types.JAVASCRIPT:
						document.body.appendChild(e.result);
						this._res[e.item.id].result = lib[e.item.id];
						break;
					default:
				}
			});

			// [#] complete method
			this.__preload.on("complete", () => {

				// [#] 스프라이트
				Object.keys(this._res).forEach((v) => {
					if (typeof this._res[v].result == 'undefined') {
						this._res[v].result = this.__duplicate[this._res[v].src];
					}
				});

				// [*] 콜백
				if (this._cb) this._cb(this._res);
			});
			this.__preload.on("error", this.handleError);

		}

		// [F]

		/**
		 * @DES :: 큐초기화 함수 - 해당 파라미터를 부모에서 정의함으로써 모든 곳에서 Res와 Callback에 접근이 가능합니다.
		 * @IP1 :: queue[obj]
		 * @IP2 :: cb[func]
		 * @S.E :: queue 예외 처리
		 */
		handleQueue(queue, cb) {
			// [CASE01] 요청 큐데이터가 있을 경우
			if (queue) {

				// [I]
				queue = JSON.parse(JSON.stringify(queue));
				// console.log(queue);

				/**
				 * TODO 병렬처리는 필요할까요 ?
				 *
				 * - 동시 다발적인 Preload는 서버의 부하를 일으킬 수 있습니다.
				 * - 약간의 로딩이 게임같은 효과를 만들 수 있습니다.
				 * */
				const arrLoad = [];
				for (const key in queue) {
					const obj = queue[key];
					if (obj.originSrc) {
						arrLoad.push({
							id: key,
							src: `${obj.originSrc}?createjs`
						});
					} else if (obj.src) {
						if (!this.__duplicate[obj.src]) {
							this.__duplicate[obj.src] = 'wait';
							obj.res = key;
							queue[key] = new this.__resModel(obj);
							arrLoad.push({
								id: key,
								src: `${this.__src}${obj.src}?createjs`
							});
						}
					} else B_Util.print('[코드모스] => 요청하신 데이터에 경로가 없는 객체가 있습니다. ');
				}7

				// [S] cache
				this._res = queue;
				this._cb = cb;

				// [#] queue load
				arrLoad.forEach((v) => {
					this.__preload.loadFile(v);
				});
			}
			// [CASE02] 요청 큐데이터가 없을 경우
			else if (cb) cb();
		}

		/**
		 * @DES :: 큐 에러시 실행되는 error catch 함수
		 * @IP1 :: e {obj}
		 */
		handleError(e) {
			B_Util.print('[코드모스] => 다음 파일의 경로를 다시 확인해주세요. ' + e.data.src);
		}
	}
}());

export default B_Preload;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/util/B_Preload.js